import { Outlet } from "react-router";
import Header from "@user/layout/header";
import Footer from "@user/layout/footer";

export default function DefaultLayout() {
  return (
    <>
      {/* <Header /> */}
      <Outlet />
      {/* <Footer /> */}
    </>
  )
}
